import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';

import { Card, CardBody, CardHeader } from 'components/common';
import { Namespace, Path } from 'enums';
import { pxToRem } from 'helpers';

import styles from './SettingsPage.module.scss';

export const SettingsPage = () => {
  const { t } = useTranslation(Namespace.Settings);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pages = useMemo(
    () => [
      {
        label: t('permissions'),
        path: Path.Permissions,
      },
      {
        label: t('conditionsForSettlements'),
        path: Path.Settlements,
      },
      {
        label: t('taxRates'),
        path: Path.Taxes,
      },
    ],
    [t],
  );

  const currentPage = useMemo(() => {
    return pages.find(({ path }) => pathname.includes(path))?.path;
  }, [pages, pathname]);

  return (
    <Card className={styles.card}>
      <CardHeader className={styles.cardHeader}>
        <h2 className="card-title">{t('settings')}</h2>
        <Tabs
          activeKey={currentPage}
          onChange={navigate}
          items={pages.map(({ label, path }) => ({ key: path, label }))}
          tabBarStyle={{
            marginTop: pxToRem(15),
            marginBottom: 0,
          }}
        />
      </CardHeader>
      <CardBody>
        <Outlet />
      </CardBody>
    </Card>
  );
};
